module.exports = __webpack_public_path__ + "img/logo10@2x.9056fb28.png";